import React, { useState } from "react";

import { StylesManager, Model } from "survey-core";
import { Survey } from "survey-react-ui";

import "survey-core/defaultV2.css";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Container } from "@mui/system";
import { ArrowBack } from "@mui/icons-material";

StylesManager.applyTheme("defaultV2");

function Answer() {
  const { data: watchPosition } = useQuery(["WatchPosition"], () => {
    return new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.watchPosition(resolve, reject);
    });
  });
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isLoading, isError, error } = useQuery(["campaign", id], async () => {
    const { data } = await axios.get(`/agent/campaigns/${id}`);
    return data as Campaign;
  });
  const [isSucces, setIsSucces] = useState(false);
  if (isLoading) {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (isError) {
    return <div>{(error as any).message}</div>;
  }
  if (isSucces) {
    return (
      <Dialog open={isSucces}>
        <DialogTitle>Thank you for your submission!</DialogTitle>
        <DialogContent>
          <p>Your submission has been recorded.</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => navigate(-1)}>Go back</Button>
          <Button onClick={() => setIsSucces(false)}>Take the survey again</Button>
        </DialogActions>
      </Dialog>
    );
  }
  const survey = new Model(data.data);
  survey.onComplete.add(async (result: any, options: any) => {
    try {
      options.showDataSaving();
      await axios.post(`agent/campaigns/${id}/answer`, {
        answer: Object.assign(result.data, {
          lng: watchPosition?.coords.longitude,
          lat: watchPosition?.coords.latitude,
        }),
      });
      options.showDataSavingSuccess();
      setIsSucces(true);
    } catch (e: any) {
      options.showDataSavingError(e?.response?.data?.message || e.message);
    }
  });
  return (
    <div>
      <Container maxWidth="md">
        <IconButton
          onClick={() => {
            navigate("/dashboard/home");
          }}>
          <ArrowBack />
        </IconButton>
      </Container>
      <Survey model={survey} />
    </div>
  );
}

export default Answer;
